import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-prospectus-modal',
  templateUrl: './new-prospectus-modal.component.html',
  styleUrls: ['./new-prospectus-modal.component.css']
})
export class NewProspectusModalComponent implements OnInit {

  title: string;

  newContact = new FormGroup({
    name: new FormControl(null, { validators: Validators.required }),
    charge: new FormControl(null, { validators: Validators.required }),
    email: new FormControl(null, [Validators.required, Validators.email]),
    phone: new FormControl(null),
  });

  constructor(public dialogRef: MatDialogRef<NewProspectusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewProspectusModalComponent) {
    this.title = data.title;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    if (this.newContact.valid){
      let response = {data: this.newContact.value, status: true}
      this.dialogRef.close(response);
    }
  }

  onDismiss(): void {
    let response = {data: null, status: false}
    this.dialogRef.close(response);
  }

}
/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
 export class NewProspectusModalModel {

  constructor(public title: string) {
  }
}
